/**
 * Signature Legacy — Media Protect (Best-effort)
 * 목적:
 * 1) video/img 우클릭 기본 메뉴 차단
 * 2) 고급 토스트 안내 표시
 * 3) 디버그 모드에서 "배지"를 고정 표시하여 로드 여부를 즉시 확인
 *
 * 디버그 켜는 법:
 * - URL 뒤에 ?sl_debug=1 붙이기
 *   예) https://.../products/xxx?sl_debug=1
 * - 또는 콘솔에서 localStorage.setItem('slMediaProtectDebug','1'); 후 새로고침
 */

(() => {
  const VERSION = "2026.01.15-r1";

  const qs = new URLSearchParams(location.search);
  const DEBUG =
    qs.get("sl_debug") === "1" ||
    localStorage.getItem("slMediaProtectDebug") === "1";

  const state = { blocked: 0 };

  function log(...args) {
    if (DEBUG) console.log("[SL Media Protect]", ...args);
  }

  // -----------------------------
  // Toast (inline style: CSS 로드 실패해도 보이게)
  // -----------------------------
  let toastEl = null;
  let toastTimer = null;

 function ensureToast() {
  if (toastEl) return toastEl;

  toastEl = document.createElement("div");
  toastEl.id = "slmp-toast";
  toastEl.setAttribute("role", "status");
  toastEl.setAttribute("aria-live", "polite");

  // ✅ 럭셔리 톤: 하단 우측, 반투명 + 블러 + 얇은 보더 + 부드러운 그림자
  toastEl.style.cssText =
    "position:fixed;" +
    "right:18px;bottom:18px;" +
    "z-index:2147483647;" +
    "max-width:min(460px,calc(100vw - 32px));" +
    "padding:14px 16px;" +
    "border-radius:16px;" +
    "border:1px solid rgba(255,255,255,.16);" +
    "background:rgba(12,12,12,.58);" +
    "backdrop-filter:blur(14px);" +
    "-webkit-backdrop-filter:blur(14px);" +
    "box-shadow:0 18px 60px rgba(0,0,0,.38);" +
    "color:rgba(255,255,255,.92);" +
    "font:500 13px/1.45 system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial;" +
    "letter-spacing:.01em;" +
    "opacity:0;" +
    "transform:translateY(10px) scale(.985);" +
    "pointer-events:none;" +
    "transition:opacity .22s ease, transform .22s ease;";

  // ✅ 작은 “시그니처” 라벨 느낌(브랜드 톤)
  const label = document.createElement("div");
  label.textContent = "SIGNATURE LEGACY • CONTENT PROTECTED";
  label.style.cssText =
    "font:600 10px/1 system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial;" +
    "letter-spacing:.22em;" +
    "text-transform:uppercase;" +
    "opacity:.72;" +
    "margin:0 0 8px 0;";

  const body = document.createElement("div");
  body.id = "slmp-toast-body";
  body.style.cssText =
    "font:500 13px/1.45 system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial;" +
    "opacity:.92;" +
    "margin:0;";

  toastEl.appendChild(label);
  toastEl.appendChild(body);
  document.body.appendChild(toastEl);

  return toastEl;
}


function showToast(message) {
  const el = ensureToast();
  const body = el.querySelector("#slmp-toast-body");
  if (body) body.textContent = message;

  // ✅ “과격하게 반복” 방지: 연속 호출 시에도 자연스럽게 갱신
  el.style.opacity = "1";
  el.style.transform = "translateY(0) scale(1)";

  clearTimeout(toastTimer);

  // ✅ 충분히 ‘고급스럽게’ 머무르기 (1.9초)
  toastTimer = setTimeout(() => {
    el.style.opacity = "0";
    el.style.transform = "translateY(10px) scale(.985)";
  }, 1900);
}


  // -----------------------------
  // Media 찾기 (Shadow DOM 대응: composedPath 사용)
  // -----------------------------
  function findMediaFromEvent(e) {
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    const nodes = path.length ? path : [e.target];

    for (const node of nodes) {
      if (!node || node === window || node === document) continue;
      if (node.nodeType !== 1) continue;

      const tag = node.tagName;
      if (tag === "VIDEO" || tag === "IMG" || tag === "IFRAME") return node;

      if (node.matches && node.matches("video, img, iframe")) return node;
    }

    // fallback
    if (e.target && e.target.closest) {
      return e.target.closest("video, img, iframe");
    }
    return null;
  }

  function isOptedOut(el) {
    return !!(el && el.closest && el.closest('[data-sl-media-protect="off"]'));
  }

  // 표식이 하나라도 있으면: 표식 내부만 보호
  function shouldProtect(mediaEl) {
    if (!mediaEl) return false;
    if (isOptedOut(mediaEl)) return false;

    const anyMarker = document.querySelector("[data-sl-media-protect]");
    if (!anyMarker) {
      // 표식이 없다면: 전체 사이트의 video/img 우클릭 방지 (미디어만)
      return true;
    }

    // 표식이 있다면: 표식 영역 안에 있는 미디어만 보호
    return !!mediaEl.closest("[data-sl-media-protect]");
  }

  function handleContextMenu(e) {
    const media = findMediaFromEvent(e);
    if (!shouldProtect(media)) return;

    // 다른 스크립트가 먼저 막아버리는 경우를 대비해, 최대한 강하게 차단
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    state.blocked += 1;

   // ✅ 럭셔리 톤 다국어 안내 (Collector / Concierge)
// - Shopify 언어(html lang) 우선, 없으면 브라우저 언어 사용
// ✅ Shopify Markets 언어까지 정확히 감지 + 메뉴명(Collector Services / Concierge) 100% 일치

// 1) 대표님 사이트 실제 메뉴명(표기)만 여기서 고정하세요.
//    예: "Collector Services" 또는 "Concierge" 또는 "Collector Concierge"
const MENU_LABEL = "Collector Services";

// 2) Shopify Markets 언어 감지 우선순위:
//    a) <html lang="en-US"> (Markets/번역앱/테마)
//    b) Shopify locale 객체 (테마에 있을 때)  ex) Shopify.locale = "en"
//    c) 브라우저 언어 navigator.language
//    d) 기본 "en"
function normalizeLocale(raw) {
  const v = String(raw || "").trim();
  if (!v) return "";
  // "en-US" -> "en", "fr-FR" -> "fr", "ja-JP" -> "ja", "ko-KR" -> "ko"
  return v.split("-")[0].toLowerCase();
}

const htmlLang = document.documentElement.getAttribute("lang"); // e.g. "en-US"
const shopifyLocale =
  (window.Shopify && (window.Shopify.locale || window.Shopify.language)) || ""; // theme dependent
const navLang = navigator.language || navigator.userLanguage || "en";

const baseLang = normalizeLocale(htmlLang) || normalizeLocale(shopifyLocale) || normalizeLocale(navLang) || "en";

// 3) 지원 언어만 허용, 그 외는 EN으로 폴백
const lang = ["en", "fr", "ja", "ko"].includes(baseLang) ? baseLang : "en";

// 4) 문장 템플릿(메뉴명은 MENU_LABEL로 자동 삽입)
//    - "Collector Services"로 넣으면 문구가 정확히 일치합니다.
const COPY = {
  en: {
    video: `This film is protected for collectors. For private viewing or licensing, please contact ${MENU_LABEL}.`,
    content: `Protected content. For private viewing or licensing, please contact ${MENU_LABEL}.`
  },
  fr: {
    video: `Ce film est protégé, réservé aux collectionneurs. Pour un visionnage privé ou une licence, veuillez contacter ${MENU_LABEL}.`,
    content: `Contenu protégé. Pour un visionnage privé ou une licence, veuillez contacter ${MENU_LABEL}.`
  },
  ja: {
    video: `本映像はコレクター向けに保護されています。ご視聴・ライセンスは${MENU_LABEL}までお問い合わせください。`,
    content: `保護コンテンツです。ご視聴・ライセンスは${MENU_LABEL}までお問い合わせください。`
  },
  ko: {
    video: `본 영상은 컬렉터를 위해 보호됩니다. 프라이빗 시청 또는 라이선스는 ${MENU_LABEL}(으)로 문의해 주세요.`,
    content: `보호된 콘텐츠입니다. 프라이빗 시청 또는 라이선스는 ${MENU_LABEL}(으)로 문의해 주세요.`
  }
};

// 5) VIDEO/IMG/기타(iframe 포함) 구분 메시지
const msg =
  media.tagName === "VIDEO"
    ? (COPY[lang] || COPY.en).video
    : (COPY[lang] || COPY.en).content;

showToast(msg);
log("blocked:", state.blocked, "target:", media, "lang:", lang, "raw:", { htmlLang, shopifyLocale, navLang });


  }

  // -----------------------------
  // Video hardening (Best-effort: 다운로드 UI 약화)
  // -----------------------------
  function hardenVideo(video) {
    if (!video || video.dataset.slmpDone === "1") return;
    video.dataset.slmpDone = "1";

    // controlsList/disablePiP는 "완벽한 보안"이 아니라 UI를 약화시키는 수준입니다.
    try {
      video.setAttribute("controlsList", "nodownload noremoteplayback");
      video.setAttribute("disablePictureInPicture", "");
    } catch (_) {}
  }

  function scanVideos() {
    document.querySelectorAll("video").forEach(hardenVideo);
  }

  // 동적으로 생성되는 video까지 커버
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!node || node.nodeType !== 1) continue;
        if (node.tagName === "VIDEO") hardenVideo(node);
        if (node.querySelectorAll) node.querySelectorAll("video").forEach(hardenVideo);
      }
    }
  });

  // -----------------------------
  // Attach listeners (CAPTURE = true가 핵심)
  // -----------------------------
  document.addEventListener("contextmenu", handleContextMenu, true);

  // drag로 이미지/비디오 끌어가기 방지(가능한 범위)
  document.addEventListener(
    "dragstart",
    (e) => {
      const media = findMediaFromEvent(e);
      if (!shouldProtect(media)) return;
      e.preventDefault();
    },
    true
  );

  // Start
  function boot() {
    scanVideos();
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Debug badge: 로드 여부를 "눈으로" 확인
    if (DEBUG) {
      const badge = document.createElement("button");
      badge.type = "button";
      badge.textContent = `SL Protect: ON (v${VERSION})`;
      badge.style.cssText =
        "position:fixed;bottom:16px;right:16px;z-index:2147483647;" +
        "padding:10px 12px;border-radius:999px;" +
        "border:1px solid rgba(255,255,255,.25);" +
        "background:rgba(16,16,16,.72);backdrop-filter:blur(12px);" +
        "color:#fff;font:600 12px/1 system-ui;letter-spacing:.02em;";
      badge.addEventListener("click", () => {
        showToast(`SL Protect loaded. Blocked: ${state.blocked}`);
      });
      document.body.appendChild(badge);
      showToast(`SL Protect debug ON (v${VERSION})`);
      log("debug enabled");
    }

    window.SLMediaProtect = { version: VERSION, debug: DEBUG, state };
    log("loaded", window.SLMediaProtect);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
